<div class="payment-result__state payment-result__state--date-expired">
  @if (message().validationDays === 0) {
    <p>
      ⚠️Solo podemos validar pagos realizados el día de hoy,
      por favor revisa tu pago con número de operación
      <strong>{{ message().operationNumber || 'no disponible' }}</strong>.
    </p>
  } @else {
    <p>
      ⚠️Solo podemos validar pagos con
      <strong>{{ message().validationDays }}</strong>
      día(s) de anterioridad, por favor revisa tu pago con número de operación
      <strong>{{ message().operationNumber || 'no disponible' }}</strong>.
    </p>
  }
</div>
